import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCustomControl, CUSTOM_CONTROL_INPUT_CHECKBOX_CLASS_NAME } from "@devowl-wp/customize";
import { __ } from "../../../utils";
import { useUpsellModal } from "@devowl-wp/react-cookie-banner-admin";
function useProModalStickyLinks() {
    return useUpsellModal({
        title: __("Want to show legal links with a sticky icon?"),
        testDrive: true,
        feature: "sticky-links",
        assetName: __("pro-modal/sticky-legal-links.webm"),
        description: __("Display a sticky icon on your website that makes the legal links easily accessible on every subpage. Not only does it look fancy, it also boosts your data protection!")
    });
}
const StickyLinksControl = ()=>{
    const { value, setValue } = useCustomControl();
    const { isPro, modal, tag } = useProModalStickyLinks();
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            modal,
            /*#__PURE__*/ _jsxs("label", {
                children: [
                    /*#__PURE__*/ _jsx("input", {
                        className: CUSTOM_CONTROL_INPUT_CHECKBOX_CLASS_NAME,
                        type: "checkbox",
                        disabled: !isPro,
                        value: "1",
                        checked: isPro ? value : false,
                        onChange: ()=>setValue(!value)
                    }),
                    __("Enable sticky links widget"),
                    " ",
                    tag
                ]
            })
        ]
    });
};
export { StickyLinksControl, useProModalStickyLinks };
